import React, { useState } from "react";
import PdfViewer from "./PdfViewer";
import ConfigPanel from "./ConfigPanel";

export default function PdfConfigScreen() {
  const [pdfFile, setPdfFile] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);

  const [anchors, setAnchors] = useState([]);
  const [fields, setFields] = useState([]);
  const [tables, setTables] = useState([]);

  return (
    <div style={styles.root}>
      <div style={styles.viewer}>
        <PdfViewer
          file={pdfFile}
          onFileLoad={setPdfFile}
          onTokenSelect={setSelectedToken}
        />
      </div>

      <div style={styles.panel}>
        <ConfigPanel
          selectedToken={selectedToken}
          anchors={anchors}
          setAnchors={setAnchors}
          fields={fields}
          setFields={setFields}
          tables={tables}
          setTables={setTables}
        />
      </div>
    </div>
  );
}

const styles = {
  root: {
    display: "flex",
    height: "100vh",
    width: "100vw",
    background: "#f4f6f8"
  },
  viewer: {
    flex: 0.7,
    borderRight: "1px solid #ccc",
    overflow: "auto"
  },
  panel: {
    flex: 0.3,
    padding: "12px",
    overflowY: "auto",
    background: "#fff"
  }
};
